import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ngIf'
})
export class NgIfPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return value.filter(x => args[1] === args[0].split('.').reduce((lastResult, currentValue) => lastResult[currentValue],  x));
  }
}
